import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

const LandingPage = () => {
    return(
        <div className="-sid-main-page">
            <div id="sheerid-headband" className="container-fluid">
                <div className="col-xs-12 center">
                    <img src="https://assets-resources.sheerid.com/tommyjohn/img/landing-logo.png" id="landing-logo" alt="Tommy John Logo"/>
                </div>
            </div>

            <div id="sheerid-header" className="container-fluid sheerid-container">

                <div className="sid-content-right-justify">

                    <div className="col-sm-offset-5 col-sm-7 col-xs-12 center">
                        <p id="title-text-one">
                            <FormattedHTMLMessage
                                id="large.title"
                                defaultMessage="20% Off For Teachers & College Students (US Only)"
                            />
                        </p>
                        <p id="promotion-details-text">
                            <FormattedHTMLMessage
                                id="large.subtitle"
                                defaultMessage="We've done our homework and are offering A+ products, so you can stay comfortable in the classroom."
                            />
                        </p>
                        <p id="promotion-instructions-text">
                            <FormattedHTMLMessage
                                id="large.subtitle2"
                                defaultMessage="Discount available for US K-12 Teachers, College Students, College Faculty, and staff only."
                            />
                        </p>
                    </div>


                    <div className="col-sm-offset-5 col-sm-7 col-xs-12 center">
                        <a data-sheerid-iframe="true" href="https://offers.sheerid.com/tommy-john-student/" className="btn btn-black" aria-label="Student Discount Button">
                                <FormattedHTMLMessage
                                    id="small.linkTextS"
                                    defaultMessage="Student"
                                />
                        </a>

                        <a data-sheerid-iframe="true" href="https://offers.sheerid.com/tommy-john-teacher/" className="btn btn-black" aria-label="Teacher Discount Button">
                                <FormattedHTMLMessage
                                    id="small.linkTextT"
                                    defaultMessage="Teacher"
                                />
                        </a>
                    </div>

                </div>

                <div className="col-sm-offset-5 col-sm-7 col-xs-12 center" id="faq-container">
                    <p id="faq-txt">
                        <a className="link-faq" href="https://verify.sheerid.com/us-teacher-faq/" target="_blank" aria-label="SheerID FAQ link">
                            <FormattedHTMLMessage
                                id="large.sheeridFaq"
                                defaultMessage="SheerID FAQs"
                            />
                        </a>
                        <img src="./Images/poweredBy_red.png" id="powered-by-img" alt="Powered by SheerID"/>
                    </p>
                </div>

            </div>

            <div id="sheerid-footer" className="container-fluid sheerid-container">
                <div className="col-xs-12 center">
                    <p id="faq-txt-mobile">
                        <a className ="link-faq-mobile" href="https://verify.sheerid.com/us-teacher-faq/" target="_blank" aria-label="SheerID FAQ Link">
                            <FormattedHTMLMessage
                                id="large.sheeridFaq"
                                defaultMessage="SheerID FAQs"
                            />
                        </a>
                        <img src="https://assets-resources.sheerid.com/tommyjohn/img/poweredBy.png" id="powered-by-img-mobile" alt="Powered by SheerID"/>
                    </p>
                </div>
            </div>
        <div id="sheerid-footband" className="container-fluid"></div>
    </div>
    )
}

export const LandingPageComponent = LandingPage;
